import React from 'react'
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const ModalSection = ({
  isOpen, 
  onClose, 
  images, 
  currentIndex, 
  onPrevious, 
  onNext 
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        <img
          src={images[currentIndex].url}
          alt={images[currentIndex].alt}
          className="max-h-[90vh] max-w-[90vw] object-contain"
        />
        
        {/* Modal navigation */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrevious();
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
        
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 hover:bg-white text-white hover:text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* Progress bar */}
      <div className="absolute bottom-0 left-0 w-full h-2 bg-white/30">
        <div 
          className="h-full bg-white transition-all duration-300 ease-out"
          style={{ width: `${((currentIndex + 1) / images.length) * 100}%` }}
        />
      </div>
    </div>
  )
}

export default ModalSection